/**
 * Read the Telegram Mini App initData string.
 *
 * Inside Telegram, `window.Telegram.WebApp.initData` is set synchronously
 * by the injected WebApp script before our bundle runs, so reading it
 * directly is safe. In a plain browser (local dev outside Telegram), the
 * global is absent and we fall back to `VITE_DEV_INIT_DATA` if set.
 *
 * The dev fallback is a hard guard against two failure modes:
 *   1. Running the dev server outside Telegram and getting opaque 401s
 *      from the backend.
 *   2. Accidentally shipping a debug initData to production — it only
 *      fires when `window.Telegram?.WebApp?.initData` is empty AND
 *      `VITE_DEV_INIT_DATA` is non-empty, which should never be the
 *      case in a real Telegram session.
 */

import { env } from '@/config/env';

export function getInitData(): string {
  const telegramInitData = window.Telegram?.WebApp?.initData ?? '';
  if (telegramInitData.length > 0) {
    return telegramInitData;
  }

  const devFallback = env.VITE_DEV_INIT_DATA?.trim() ?? '';
  if (devFallback.length > 0) {
    // Only print this warning once per session.
    if (!getInitData._warned) {
      console.warn(
        '[telegram] Using VITE_DEV_INIT_DATA fallback. Never use this value outside local development.',
      );
      getInitData._warned = true;
    }
    return devFallback;
  }

  return '';
}
// Tag the function to avoid repeat warnings.
getInitData._warned = false as boolean;

export function hasInitData(): boolean {
  return getInitData().length > 0;
}
